/* eslint-disable react/display-name */
import InternalUserManagement from 'pages/private/InternalUser';
import CompletedTrainig from 'pages/user-private-route/CompletedTraining';
import Course from 'pages/user-private-route/Course';
import CourseDetail from 'pages/user-private-route/Course/CourseDetail';
import CourseEnrolled from 'pages/user-private-route/Course/CourseEnrolled';
import MCQ from 'pages/user-private-route/Course/CourseEnrolled/MCQ';

import UserDashboard from 'pages/user-private-route/Dashboard';
import DashboardTrainee from 'pages/user-private-route/Dashboard/Trainee';
import UserSideBar from 'pages/user-private-route/Sidebar';
import TraineeProfile from 'pages/user-private-route/TraineeProfile';
import { BiUserCircle } from 'react-icons/bi';
import { MdDashboard } from 'react-icons/md';
// import { GrCertificate } from 'react-icons/gr';

const style = { color: 'white', className: 'nav-icon', size: 30 };
export const userPrivateRoutes = [
  {
    path: '/',
    title: 'Sidebar',
    element: <UserSideBar />,
    children: [
      {
        title: 'Dashboard',
        path: '/',
        index: true,
        icon: <MdDashboard style={style} />,
        element: <UserDashboard />,
        isForTrainee: true,
        isDivider: true
      },
      {
        title: 'Profile',
        path: '/internal-user-management',
        icon: <BiUserCircle style={style} />,
        element: <InternalUserManagement />,
        isDivider: true
      },
      {
        title: 'Profile',
        path: '/completedTraining',
        icon: <BiUserCircle style={style} />,
        element: <CompletedTrainig />,
        isDivider: true
      },
      {
        title: 'Course',
        path: '/course',
        icon: <BiUserCircle style={style} />,
        element: <Course />,
        isDivider: true
      },
      {
        title: 'Course',
        path: '/course/detail/:id',
        icon: <BiUserCircle style={style} />,
        element: <CourseDetail />,
        isDivider: true
      },
      {
        title: 'Profile',
        path: '/profile',
        element: <TraineeProfile />,
        icon: <BiUserCircle style={style} />,
        isDivider: true
      },
      {
        title: 'Training',
        path: '/training/:training_id',
        element: <DashboardTrainee />,
        icon: <BiUserCircle style={style} />,
        isDivider: true
      },
            {
        title: 'Course View',
        path: '/course/enroll/view/:id',
        element: <CourseEnrolled />,
        icon: <BiUserCircle style={style} />,
        isDivider: true
      },
             {
        title: 'Course Detail',
        path: '/course/detail/:id',
        element: <CourseDetail />,
        icon: <BiUserCircle style={style} />,
        isDivider: true
      },
        {
        title: 'MCQ',
        path: '/course/enroll/view/moduleid=:mid/:sessionID/:id/mcq',
        element: <MCQ />,
        icon: <BiUserCircle style={style} />,
        isDivider: true
      }
    ]
  }
];
